
import { put, takeEvery } from "redux-saga/effects";
import { IM_PLANT, IM_PLANT_ERROR, IM_PLANT_SUCCESS } from "../Types/plantIM.constant";

export function* setSelectedPlant(action: any): any {
    try {
        yield put({
            type: IM_PLANT_SUCCESS,
            payload: action.payload,
        });
    } catch (error) {
        yield put({
            type: IM_PLANT_ERROR,
            payload: null,
        });
    }
}

export function* injectionMoldingSaga() {
    yield takeEvery(IM_PLANT, setSelectedPlant);
}